// extracted by mini-css-extract-plugin
export default {"timestampNeedle":"TimestampNeedle-module__timestampNeedle_QB6SL"};